
export default {
  name: 'IdentidadIcon',
}
